(function() {
  'use strict';

  var B2B_FORM_ID = 'forms-root-1231822';
  var B2C_FORM_ID = 'forms-root-1231841';
  var translations = window.eabRegistrationTranslations || {};
  var companyLabel = translations.company || 'Company';
  var privatePersonLabel = translations.privatePerson || 'Private individual';

  function getFormSection(formId) {
    var formRoot = document.querySelector('[data-forms-id="' + formId + '"]');
    return formRoot ? formRoot.closest('.shopify-section') : null;
  }

  function initRegisterFormsToggle() {
    var mainContent = document.getElementById('MainContent');
    var b2bSection = getFormSection(B2B_FORM_ID);
    var b2cSection = getFormSection(B2C_FORM_ID);

    if (!mainContent || document.querySelector('.register-forms-toggle')) {
      return;
    }

    if (!b2bSection || !b2cSection) {
      return false;
    }

    var toggle = document.createElement('div');
    toggle.className = 'register-forms-toggle';
    toggle.setAttribute('role', 'tablist');
    toggle.setAttribute('aria-label', 'Välj registreringstyp');
    toggle.innerHTML =
      '<button type="button" class="register-forms-toggle__button is-active" role="tab" aria-selected="true" aria-controls="' + b2bSection.id + '" data-form-target="b2b"></button>' +
      '<button type="button" class="register-forms-toggle__button" role="tab" aria-selected="false" aria-controls="' + b2cSection.id + '" data-form-target="b2c"></button>';

    toggle.querySelector('[data-form-target="b2b"]').textContent = companyLabel;
    toggle.querySelector('[data-form-target="b2c"]').textContent = privatePersonLabel;

    b2bSection.before(toggle);

    function showForm(type) {
      var showB2B = type === 'b2b';
      b2bSection.hidden = !showB2B;
      b2cSection.hidden = showB2B;

      toggle.querySelectorAll('[data-form-target]').forEach(function(button) {
        var isActive = button.dataset.formTarget === type;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-selected', String(isActive));
      });
    }

    toggle.addEventListener('click', function(event) {
      var button = event.target.closest('[data-form-target]');
      if (button) {
        showForm(button.dataset.formTarget);
      }
    });

    showForm('b2b');
    return true;
  }

  function watchForForms() {
    if (initRegisterFormsToggle()) {
      return;
    }

    var observer = new MutationObserver(function() {
      if (initRegisterFormsToggle()) {
        observer.disconnect();
      }
    });

    observer.observe(document.getElementById('MainContent') || document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchForForms);
  } else {
    watchForForms();
  }
})();
